export default __webpack_public_path__ + "static/media/energy.6be5e542.jpg";